import {instance} from './index';

export interface QuestionOption {
  id: string;
  value: string;
}

export interface Question {
  id: string;
  title: string;
  description: string;
  dataType: string;
  isRequired: boolean;
  position: number;
  allowMultipleAnswers: boolean;
  options: QuestionOption[];
}

export async function getFollowUpQuestions(idSet: string) {
  const response = await instance().get<Question[]>(
    `/v2/answer-sets/${idSet}/follow-up-questions`,
  );

  return response.data;
}

export interface FollowUpAnswer {
  id: string;
  idQuestion: string;
  question: string;
  rawAnswer?: string | string[] | null | number;
}

export async function saveFollowUpAnswer(
  idSet: string,
  data: Omit<FollowUpAnswer, 'id' | 'question'>,
) {
  const response = await instance().put<FollowUpAnswer>(
    `/v2/answer-sets/${idSet}/follow-up-answers`,
    data,
  );
  return response.data;
}

export async function getFollowUpAnswers(idSet: string) {
  const response = await instance().get<FollowUpAnswer[]>(
    `/v2/answer-sets/${idSet}/follow-up-answers`,
  );
  return response.data;
}

interface AnswerSetsResponse {
  id: string;
  idUser: string;
  idForm: string;
  idEvent: string;
  startedAt: string;
  completedAt: string;
  formSetNumber: number;
  userFormSetNumber: number;
  prettyAnswers: Record<string, string | number | null | undefined>;
}

export async function getAnswerSetsByFormAndDate(idForm: string, date: string) {
  return instance()
    .get<AnswerSetsResponse[]>('/v2/answer-sets', {
      params: {
        idForm,
        date,
      },
    })
    .then(r => r.data);
}
